/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineRewardsService() {
        let rewardsService = {};
        rewardsService.exportCustomerTransactionsAsCsv = function (request) {
            return axios.post("/api/RewardsService/ExportCustomerTransactionsAsCsv", request, { responseType: 'blob' });
        };
        rewardsService.getCustomerTransactions = function (request) {
            return axios.post("/api/RewardsService/GetCustomerTransactions", request).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        rewardsService.getCustomerAccount = function (personId) {
            return axios.get("/api/RewardsService/GetCustomerAccount?personId=" + personId).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        rewardsService.getTransactionDetails = function (request) {
            return axios.post("/api/RewardsService/GetTransactionDetails", request).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        rewardsService.getTransactionTypes = function () {
            return axios.get("/api/RewardsService/GetTransactionTypes").then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        rewardsService.getPromotions = function (request) {
            return axios.post("/api/RewardsService/GetPromotions", request).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        rewardsService.getPromotion = function (promotionId) {
            return axios.get("/api/RewardsService/GetPromotion?promotionId=" + promotionId).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        rewardsService.addOrUpdatePromotion = function (request) {
            return axios.post("/api/RewardsService/AddOrUpdatePromotion", request).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        rewardsService.getProducts = function (request) {
            return axios.post("/api/RewardsService/GetProducts", request).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        rewardsService.getPromotionProductsForPromotion = function (promotionId) {
            return axios.get("/api/RewardsService/GetPromotionProductsForPromotion?promotionId=" + promotionId).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        rewardsService.unlinkProductsFromPromotion = function (request) {
            return axios.post("/api/RewardsService/UnlinkProductsFromPromotion", request).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        rewardsService.markPromotionAsActiveOrInActive = function (request) {
            return axios.post("/api/RewardsService/MarkPromotionAsActiveOrInActive", request).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        rewardsService.getProductPointValuesEarnings = function (request) {
            return axios.post("/api/RewardsService/GetProductPointValuesEarnings", request).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        rewardsService.getProductPointValuesRedemptions = function (request) {
            return axios.post("/api/RewardsService/GetProductPointValuesRedemptions", request).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        rewardsService.updateProductPointValuesRedeem = function (request) {
            return axios.post("/api/RewardsService/UpdateProductPointValuesRedeem", request).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        return rewardsService;
    }
    //define globally if it doesn't already exist
    if (typeof (rewardsService) === "undefined") {
        window.rewardsService = defineRewardsService();
    } else {
        console.log("rewardsService already defined.");
    }
})(window);